import styled, { css } from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const Aside = styled.div.withConfig({
    displayName: "styled__Aside",
    componentId: "sc-bd44f13e-0"
})`
	${FlexMixin({
    justify: 'center'
})}
	margin-bottom: 22px;
	width: 100%;
	@media (max-width: 1350px) {
		${FlexMixin({
    direction: 'column',
    justify: 'flex-start'
})}
		margin-right: 42px;
		max-width: 280px;
		width: initial;
	}
	@media (max-width: 1160px) {
		margin-right: 32px;
	}

	@media (max-width: 1100px) {
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
		${FlexMixin({
    direction: 'row'
})}
		margin-right: 0;
		max-width: initial;
		width: 100%;
	}
`;
export const Highlight = styled.div.withConfig({
    displayName: "styled__Highlight",
    componentId: "sc-bd44f13e-1"
})`
	${FlexMixin()}
	margin-right: 40px;
	@media (max-width: 1350px) {
		margin-right: 0;
		margin-bottom: 20px;
	}

	@media (max-width: 1100px) {
		margin-right: 40px;
		margin-bottom: 24px;
		align-items: center;
	}
`;
export const MenuIcon = styled.span.withConfig({
    displayName: "styled__MenuIcon",
    componentId: "sc-bd44f13e-2"
})`
	${FontMixin({
    size: 'xl',
    weight: 'regular'
})}
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	border-radius: 50%;
	width: 80px;
	height: 80px;
	min-width: 80px;
	min-height: 80px;
	color: ${({ theme  })=>theme.colors.white.base};

	@media (max-width: 1100px) {
		width: 72px;
		height: 72px;
		min-width: 72px;
		min-height: 72px;
	}

	${({ icon  })=>{
    if (icon === 'piggy-bank') {
        return css`
				background-color: ${({ theme  })=>theme.colors.status.success};
			`;
    }
    if (icon === 'calendar-cancel') {
        return css`
				background-color: ${({ theme  })=>theme.colors.status.complementary2};
			`;
    }
    if (icon === 'euro-highlight') {
        return css`
				background-color: ${({ theme  })=>theme.colors.primary.lighter};
			`;
    }
    if (icon === 'travelsafe-logi') {
        return css`
				background-color: ${({ theme  })=>theme.colors.secondary.base};
			`;
    }
}}
`;
export const Wrapper = styled.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-bd44f13e-3"
})``;
export const Title = styled.h5.withConfig({
    displayName: "styled__Title",
    componentId: "sc-bd44f13e-4"
})`
	color: ${({ theme  })=>theme.colors.status.info};
	display: block;
	${FontMixin({
    size: 'large',
    weight: 'bold'
})}
	margin-left: 12px;
	margin-top: 16px;
	line-height: 22px;
	text-transform: uppercase;
	@media (max-width: 1350px) {
		${FontMixin({
    size: 'base',
    weight: 'bold'
})}
	}
`;
export const Subtitle = styled.p.withConfig({
    displayName: "styled__Subtitle",
    componentId: "sc-bd44f13e-5"
})`
	display: block;
	color: ${({ theme  })=>theme.colors.status.info};
	${FontMixin({
    size: 'base',
    weight: 'regular'
})}
	margin-left: 12px;
	padding-bottom: 8px;
	line-height: 22px;
	text-transform: uppercase;
	@media (max-width: 1100px) {
		${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
	}
`;
export const Prominents = styled.ul.withConfig({
    displayName: "styled__Prominents",
    componentId: "sc-bd44f13e-6"
})`
	${({ icon  })=>{
    if (icon === 'travelsafe-logi') {
        return css`
				border: 2px solid ${({ theme  })=>theme.colors.status.success};
				::after {
					border-top: 2px solid ${({ theme  })=>theme.colors.status.success};
					border-left: 2px solid ${({ theme  })=>theme.colors.status.success};
				}
			`;
    }
    if (icon === 'piggy-bank') {
        return css`
				border: 2px solid ${({ theme  })=>theme.colors.status.complementary2};
				::after {
					border-top: 2px solid ${({ theme  })=>theme.colors.status.complementary2};
					border-left: 2px solid ${({ theme  })=>theme.colors.status.complementary2};
				}
			`;
    }
    if (icon === 'calendar-cancel') {
        return css`
				border: 2px solid ${({ theme  })=>theme.colors.primary.lighter};
				::after {
					border-top: 2px solid ${({ theme  })=>theme.colors.primary.lighter};
					border-left: 2px solid ${({ theme  })=>theme.colors.primary.lighter};
				}
			`;
    }
    if (icon === 'euro-highlight') {
        return css`
				border: 2px solid ${({ theme  })=>theme.colors.secondary.base};
				::after {
					border-top: 2px solid ${({ theme  })=>theme.colors.secondary.base};
					border-left: 2px solid ${({ theme  })=>theme.colors.secondary.base};
				}
			`;
    }
}}
	position: relative;
	background-color: ${({ theme  })=>theme.colors.white.base};
	border-radius: 4px;
	padding: 16px;
	margin-top: 10px;
	z-index: 1;

	::after {
		content: '';
		position: absolute;
		background-color: ${({ theme  })=>theme.colors.white.base};
		width: 15px;
		height: 15px;
		top: -2px;
		transform: translate(50%, -50%) rotate(45deg);
		z-index: 0;
	}
`;
export const List = styled.li.withConfig({
    displayName: "styled__List",
    componentId: "sc-bd44f13e-7"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
	${FlexMixin()}
	color: ${({ theme  })=>theme.colors.status.info};
	line-height: 20px;
	margin-bottom: 4px;
`;
export const Check = styled.i.withConfig({
    displayName: "styled__Check",
    componentId: "sc-bd44f13e-8"
})`
	margin-right: 8px;
	${FontMixin({
    size: 'medium',
    weight: 'regular'
})}
`;

//# sourceMappingURL=styled.js.map